// extracted by mini-css-extract-plugin
module.exports = {"button-icon":"button-icon__button-icon___3w1vl"};